// extracted by mini-css-extract-plugin
module.exports = {"container":"MeetingInformationSlider_container__1TSOL","image":"MeetingInformationSlider_image__1jJ09","imageFlip":"MeetingInformationSlider_imageFlip__3RctA"};